import React from 'react';
import { usePathname } from 'next/navigation';
import * as S from './HeaderTitle.styles';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { ROUTES } from '@/constants/routes';
import { LogoLink } from '@/components/LogoLink/LogoLink';
import { useBreakpoint } from '@/hooks/useBreakpoint';

interface HeaderTitleProps {
  title?: string;
}

export const HeaderTitle = ({ title }: HeaderTitleProps) => {
  const { isDesktop } = useBreakpoint();
  const pathname = usePathname();

  const [isDesktopCatalogueOpen, toggleDesktopCatalogue] =
    useDesktopCatalogueStore(state => [
      state.isDesktopCatalogueOpen,
      state.toggleDesktopCatalogue,
    ]);
  const [isNavOpen, toggleNav] = useNavMenuStore(state => [
    state.isNavOpen,
    state.toggleNav,
  ]);

  const isBookmarksPage = pathname === ROUTES.bookmarks;

  function onLogoLinkClick() {
    if (isDesktopCatalogueOpen) toggleDesktopCatalogue();
    if (isNavOpen) toggleNav();
  }

  return title && !isDesktop ? (
    <S.HeaderTitleBox {...(isBookmarksPage && { as: 'h1' })}>
      {title}
    </S.HeaderTitleBox>
  ) : (
    <LogoLink onClick={onLogoLinkClick} />
  );
};
